import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import ErrorBoundary from "./commonComponent/ErrorBoundary";

import NotFound from "./NotFound";
import { ClinicRoutes as ClinicRoutesNew } from "./clinic/routes";
import { PatientRoutes } from "./patient/routes";
import "./main.css";
import { PatientContextProvider } from "./patient/context/PatientContext";
import BrokenComponent from "./BrokenComponent";

const App = () => {
  return (
    <Router>
      <ErrorBoundary>
        <Routes>
          <Route path="/" element={<Navigate to="/clinic/login" />} />
          <Route path="/404" element={<NotFound />} />
          <Route path="/broken" element={<BrokenComponent />} />
          <Route path="/clinic/*" element={<ClinicRoutesNew />} />
          <Route
            path="/patient/*"
            element={
              <PatientContextProvider>
                <PatientRoutes />
              </PatientContextProvider>
            }
          />
        </Routes>
      </ErrorBoundary>
    </Router>
  );
};
//

export default App;
